module.exports = __webpack_public_path__ + "static/parcolympique-logo-ece4c0611db35b71edab7de637728b72.jpg";